import { IMaintenanceFilterState } from '../../store/reducer/schedule-maintenance/MaintenanceFilterReducer';

/**
 * @method getFilterParams
 * @description Gets the current filter parameters for Maintenance.
 * If the search url has params use those; otherwise fall back to Redux filter state.
 * @param search - The search url
 * @param filterState - The current filter state from Redux
 * @returns The filter parameters object
 */
export const getFilterParams = (search: string, filterState: IMaintenanceFilterState) => {
  const params = new URLSearchParams(search);
  const parsedParams = {
    search: params.get('search') ?? '',
    status: params.get('status') ?? '',
    sortColumn: params.get('sortColumn') ?? '',
    sortType: params.get('sortType') ?? '',
    page: params.get('page') ?? '',
    item: params.get('item') ?? '',
  };

  const hasUrlFilter = parsedParams.search
    || parsedParams.status
    || parsedParams.sortColumn
    || parsedParams.sortType;

  if (hasUrlFilter) {
    return parsedParams;
  }

  return {
    search: filterState.searchText ?? '',
    status: filterState.status ?? '',
    sortColumn: filterState.sortColumn ?? '',
    sortType: filterState.sortType ?? '',
    page: params.get('page') ?? '',
    item: params.get('item') ?? '',
  };
};
